export enum ReportItemField {
  ORDER_PROGRESS = 'ORDER_PROGRESS',
  QTY_PRODUCED = 'QTY_PRODUCED',
  PICKS_PRODUCED = 'PICKS_PRODUCED',
  QTY_REQUIRED = 'QTY_REQUIRED',
  PICKS_REQUIRED = 'PICKS_REQUIRED'
}
